export const POLICY_NOTE_START = 'POLICY_NOTE_START';
export const POLICY_NOTE_SUCCESS = 'POLICY_NOTE_SUCCESS';
export const POLICY_NOTE_FAILED = 'POLICY_NOTE_FAILED';
export const POLICY_NOTE_ADD_START = 'POLICY_NOTE_ADD_START';
export const POLICY_NOTE_ADD_SUCCESS = 'POLICY_NOTE_ADD_SUCCESS';
export const POLICY_NOTE_ADD_FAILED = 'POLICY_NOTE_ADD_FAILED';

export interface PolicyNoteRequest {
  ownerType: string;
  ownerCode: string;
  note?: Note;
}

export interface Note {
  title?: string;
  summary?: string;
  detail?: string;
  createdAt?: string;
  createdBy?: string;
  agentCode?: string;
  userType?: string;
}

export interface PolicyNotesStore {
  noteFetched?: boolean;
  loading?: boolean;
  noteError?: unknown;
  note?: PolicyNotesResponse[];
}

export interface PolicyNotesResponse {
  policyNumber?: string;
  id?: string;
  notes?: NoteField[];
}

export interface NoteField {
  note?: {
    title?: string;
    summary?: string;
    detail?: string;
    createdAt?: string;
    createdBy?: string;
    agentCode?: string;
  };
  id?: string;
}
